import {
  dayNames,
  monthNames,
  yesNoOption,
  yesNoNAOption,
  passFailOption,
  leveedAreaOption,
  systemTypeOption,
  alignmentAdjustmentOption,
  textOption,
  dateOption,
  boolOption,
  linkOption,
  emailOption,
  demDates,
  processingHoverText,
  detailedQCHoverText,
  geospatialQCHoverText,
  reasonablenessQCHoverText,
  initialQCHoverText,
  initialAnalystHoverText,
  finalQCHoverText
} from './data';

const config = {
  bugReporting: {
    mailTo: [
      'sputnam@dewberry.com',
      'awcurtis@dewberry.com',
      'akopti@dewberry.com'
    ],
    cc: []
  },
  msalConfig: {
    auth: {
      clientId: process.env.REACT_APP_AZ_CLIENT_ID,
      authority:
        'https://login.microsoftonline.com/' +
        process.env.REACT_APP_AZ_TENET_ID,
      redirectUri: process.env.REACT_APP_AUTH_REDIRECT
    },
    cache: {
      cacheLocation: 'localStorage', // This configures where your cache will be stored
      storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    }
  },

  saveTokenLocalStorage: (tkn) => {
    localStorage.setItem('token', JSON.stringify(tkn));
  },

  getTokenLocalStorage: () => {
    const tokenString = localStorage.getItem('token');
    return JSON.parse(tokenString);
  },

  getDecodedTokenLocalStorage: () => {
    let tokenString = JSON.parse(localStorage.getItem('token'));
    if (tokenString) {
      let base64Url = tokenString.split('.')[1];
      let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      let jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );
      return JSON.parse(jsonPayload);
    }
    return null;
  },

  clearTokenLocalStorage: () => {
    localStorage.removeItem('token');
  },

  sumOfObjectValues: (data) => {
    return Object.values(data).reduce((a, b) => a + b);
  },

  deleteItemFromArray: (arr, item) => {
    return arr.filter(function (e) {
      return e !== item;
    });
  },

  getCurrentDateTime: () => {
    const dt = new Date();
    const month = dt.getUTCMonth() + 1;
    const day = dt.getUTCDate();
    const year = dt.getUTCFullYear();
    const dtStr = dt.toUTCString();
    const time = dtStr
      .slice(17, dtStr.length)
      .replaceAll(':', '_')
      .replaceAll(' ', '_');
    return `${month}-${day}-${year}_${time}`;
  },

  monthNames: monthNames,

  dayNames: dayNames,

  loginRequest: {
    scopes: ['User.Read']
  },

  graphConfig: {
    graphMeEndpoint: 'https://graph.microsoft.com/beta/me'
  },
  pageSize: 10,
  finderMultiSelect: {
    'Detailed Status': {
      'Ready for NLD Update': 'USACE Not Selected for Review,USACE Approved'
    }
  },
  customReports: {
    canAccess: ['admin', 'usace', 'pts_admin', 'fema'],
    dropdownOptions: {
      'Flood Runout by Year': 'flood_runout_by_year'
    },
    requestURLs: {
      flood_runout_by_year:
        '/nld_tracker/finder/custom_report?reason=Flood Runout'
    }
  },
  plots: {
    donut: {
      defaultSystems: '2024',
      dropdownOptions: {
        'All Non-USACE Systems': '-9999',
        '2024 Priority Non-USACE Systems': '2024',
        '2023 Priority Non-USACE Systems': '2023',
        '2022 Priority Non-USACE Systems': '2022',
        '2021 Priority Non-USACE Systems': '2021'
      },
      titleByOption: {
        '-9999': 'All Non-USACE Systems',
        2024: '2024 Priority Non-USACE Systems',
        2023: '2023 Priority Non-USACE Systems',
        2022: '2022 Priority Non-USACE Systems',
        2021: '2021 Priority Non-USACE Systems'
      },
      colors: {
        'NLD Updated': '#c70039',
        'NLD Not Updated': '#1d8348',
        'Through Reasonableness Only': '#900c3f',
        'In Progress': '#ffc300',
        'Pre-processed - Ready': '#ff8d1a',
        'Pre-processed - Incomplete': '#ff5733',
        'Parking Lot': '#511849',
        'Parking Lot (Recommended)': '#855d80',
        'Flood Runout': '#00baad',
        'Flood Runout (Recommended)': '#4dcfc6',
        'Coastal Analysis': '#4287ff',
        'Coastal Analysis (Recommended)': '#1972bf',
        'Long Floodwall': '#57c785',
        'Long Floodwall (Recommended)': '#89d8aa',
        'No HQ DEM': '#3d3d6b',
        'No HQ DEM (Recommended)': '#777797',
        Other: '#d5c74b',
        'Other (Recommended)': '#efe064',
        'Partial HQ DEM': '#2a7b9b',
        'Partial HQ DEM (Recommended)': '#6aa3b9',
        'Evaluated by Others': '#add45c',
        'Evaluated by Others (Recommended)': '#c6e18d'
      },
      structures: {
        positions: { pieX: '31%', textY: '50%', legendLeft: '58.5%' }
      },
      statuscount: {
        positions: { pieX: '24%', textY: '50%', legendLeft: '51.5%' }
      },
      parkinglot: {
        positions: { pieX: '24%', textY: '50%', legendLeft: '53.5%' }
      }
    },
    line: {
      defaultStatuses: [
        'complete_usace_complete',
        'usace_complete',
        'complete',
        'in_progress'
      ],
      allStatuses: [
        'complete_usace_complete',
        'usace_complete',
        'complete',
        'in_progress',
        'parking_lot',
        'parking_lot_recommended',
        'parking_lot_no_dem',
        'parking_lot_partial_dem',
        'parking_lot_flood_runout',
        'parking_lot_long_floodwall',
        'parking_lot_coastal_analysis',
        'parking_lot_evaluated_by_others',
        'parking_lot_other',
        'pre_processed_ready',
        'pre_processed_incomplete'
      ],
      dropdownOptions: {
        'Reasonableness Only + NLD Updated': 'complete_usace_complete',
        'NLD Updated': 'usace_complete',
        'Through Reasonableness Only': 'complete',
        'In Progress': 'in_progress',
        'Parking Lot': 'parking_lot',
        'Parking Lot (Recommended)': 'parking_lot_recommended',
        'Parking Lot - No HQ DEM': 'parking_lot_no_dem',
        'Parking Lot - Partial HQ DEM': 'parking_lot_partial_dem',
        'Parking Lot - Flood Runout': 'parking_lot_flood_runout',
        'Parking Lot - Long Floodwall': 'parking_lot_long_floodwall',
        'Parking Lot - Coastal Analysis': 'parking_lot_coastal_analysis',
        'Parking Lot - Evaluated by Others': 'parking_lot_evaluated_by_others',
        'Parking Lot - Other': 'parking_lot_other',
        'Pre-processed - Ready': 'pre_processed_ready',
        'Pre-processed - Incomplete': 'pre_processed_incomplete'
      },
      colors: {
        'Reasonableness Only + NLD Updated': '#077a38',
        'NLD Updated': '#c70039',
        'Through Reasonableness Only': '#900c3f',
        'In Progress': '#ffc300',
        'Parking Lot': '#511849',
        'Parking Lot (Recommended)': '#855d80',
        'Parking Lot - No HQ DEM': '#3d3d6b',
        'Parking Lot - Partial HQ DEM': '#2a7b9b',
        'Parking Lot - Flood Runout': '#00baad',
        'Parking Lot - Long Floodwall': '#57c785',
        'Parking Lot - Coastal Analysis': '#4287ff',
        'Parking Lot - Evaluated by Others': '#add45c',
        'Parking Lot - Other': '#d5c74b',
        'Pre-processed - Ready': '#ff8d1a',
        'Pre-processed - Incomplete': '#ff5733'
      }
    }
  },
  fieldsChangedInit: {
    // The keys are used by useFieldsChangedContext
    // to monitor if fields changed and unsaved
    //   to prompt user to save before switching streamline vs original
    processing: false,
    detailedQC: false,
    geospatialQC: false,
    reasonablenessQC: false,
    initialQC: false,
    initialAnalyst: false,
    finalQC: false
  },
  fieldsChangedLabels: {
    processing: 'Processing Details',
    detailedQC: 'Detailed QC',
    geospatialQC: 'Geospatial QC',
    reasonablenessQC: 'Reasonableness QC',
    initialQC: 'Initial QC',
    initialAnalyst: 'Initial Analyst',
    finalQC: 'Final QC'
  },
  originalTables: [
    'Pre-Processing Details',
    'Processing Details',
    'Detailed QC',
    'Geospatial QC',
    'Reasonableness QC',
    'USACE QA',
    'USACE Actions'
  ],
  streamlineTables: [
    'Pre-Processing Details',
    'Initial QC',
    'Initial Analyst',
    'Final QC',
    'USACE QA',
    'USACE Actions'
  ],
  canToggleStreamline: ['admin', 'usace', 'pts_admin', 'pts_reviewer'],
  tables: {
    systemMetadata: {
      title: 'System Metadata',
      inputOptions: {
        Priority: { rowType: 'nullInt' },
        'NLD System Summary': linkOption,
        'BucketView Data Directory': linkOption
      },
      canUpdate: [],
      statusOptions: {}
    },

    preProcessing: {
      title: 'Pre-Processing Details',
      inputOptions: {
        'NLD Alignment Lines': boolOption,
        'NLD Leveed Areas': boolOption,
        'Complete DEM': boolOption,
        'Geopackage Initialized': boolOption,
        'Transects Available': boolOption,
        'Last Saved': dateOption,
        Email: emailOption
      },
      canUpdate: [],
      statusOptions: {}
    },
    processing: {
      title: 'Processing Details',
      hoverText: processingHoverText,
      inputOptions: {
        'Type of System': systemTypeOption,
        'FIRM/NFHL Symbol': yesNoOption,
        'Alignment on Levee Crest': yesNoOption,
        'Added New Features': yesNoOption,
        'Alignment has Closure': yesNoOption,
        'Alignment has Floodwall': yesNoOption,
        'Alignment has Road': yesNoOption,
        'Alignment has Railroad': yesNoOption,
        'Alignment has High Ground': yesNoOption,
        'Alignment has Bridge (CA style)': yesNoOption,
        'Alignment Lines Upstream to Downstream': yesNoOption,
        'Alignment Lines in Same Direction': yesNoOption,
        'Transects in Same Direction': yesNoOption,
        'No Break between Two Connecting Alignment Lines': yesNoOption,
        'Transects have idx Values': yesNoOption,
        'Transects Cross': yesNoOption,
        'Leveed Area at DEM Extent': yesNoOption,
        'Leveed Area Special Case': yesNoOption,
        'Best Leveed Area Method': leveedAreaOption,
        'Leveed Area Snapped to Alignment': yesNoOption,
        'MaxEl Points on Levee Centerline': yesNoOption,
        'Alignment Updated': yesNoOption,
        'Leveed Area Updated': yesNoOption,
        'Report Run': yesNoOption,
        Notes: textOption,
        'Last Saved': dateOption,
        Email: emailOption
      },
      canUpdate: ['admin', 'usace', 'pts_admin', 'pts_reviewer', 'pts_analyst'],
      statusOptions: {
        'In Progress': 'in_process',
        Complete: 'ready_for_review_detailed'
      }
    },
    detailedQC: {
      title: 'Detailed QC',
      hoverText: detailedQCHoverText,
      inputOptions: {
        'Processing Metadata': passFailOption,
        'Alignment Location': passFailOption,
        'Alignment Height': passFailOption,
        'Alignment Type': passFailOption,
        'Entire Length of Protection Captured': passFailOption,
        'Floodwalls/Closures': passFailOption,
        Notes: textOption,
        'Last Saved': dateOption,
        Email: emailOption
      },
      canUpdate: ['admin', 'usace', 'pts_admin', 'pts_reviewer'],
      statusOptions: {
        'In Progress': 'in_review_detailed',
        Complete: 'ready_for_review_geospatial',
        'Changes Requested': 'changes_requested'
      }
    },
    geospatialQC: {
      title: 'Geospatial QC',
      hoverText: geospatialQCHoverText,
      inputOptions: {
        'Alignment Orientation': passFailOption,
        'No Break between Two Connecting Alignment Lines': passFailOption,
        'Alignment Elevation Units': passFailOption,
        'Polygon Valid': passFailOption,
        'Polygon Vertices': passFailOption,
        'Majority of Interior Holes Removed': passFailOption,
        Notes: textOption,
        'Last Saved': dateOption,
        Email: emailOption
      },
      canUpdate: ['admin', 'usace', 'pts_admin', 'pts_reviewer'],
      statusOptions: {
        'In Progress': 'in_review_geospatial',
        Complete: 'ready_for_review_reasonableness',
        'Changes Requested': 'changes_requested'
      }
    },
    reasonablenessQC: {
      title: 'Reasonableness QC',
      hoverText: reasonablenessQCHoverText,
      inputOptions: {
        'Type of System': systemTypeOption,
        'Leveed Area Method': leveedAreaOption,
        'Elevation Source': {
          rowType: 'dropdown',
          rowOptions: ['1-meter or better', '3-meter', 'Other']
        },
        'Elevation Date': {
          rowType: 'dropdown',
          rowOptions: demDates
        },
        'Geopackage Complete': passFailOption,
        'Transect with Toes Complete': passFailOption,
        'Alignment Acceptable': passFailOption,
        'Alignment Cartography': {
          rowType: 'dropdown',
          rowOptions: ['Better', 'Worse', 'Same']
        },
        'Leveed Area Acceptable': passFailOption,
        'DEM Acceptable': passFailOption,
        'Orthoimage Acceptable': passFailOption,
        'USACE Recommendation': {
          rowType: 'dropdown',
          rowOptions: ['Update', 'Remove', 'Recategorize']
        },
        'Final Notes': textOption,
        'Last Saved': dateOption,
        Email: emailOption
      },
      canUpdate: ['admin', 'usace', 'pts_admin'],
      statusOptions: {
        'In Progress': 'in_review_reasonableness',
        Complete: 'complete_usace_ready_for_review',
        'Changes Requested': 'changes_requested'
      }
    },
    usaceQC: {
      title: 'USACE QA',
      inputOptions: {
        Notes: textOption,
        'Last Saved': dateOption,
        Email: emailOption
      },
      canUpdate: ['admin', 'usace'],
      statusOptions: {
        'In Progress': 'complete_usace_in_review',
        'Not Selected for Review': 'complete_usace_not_selected_for_review',
        Approved: 'complete_usace_approved',
        'Changes Requested': 'complete_usace_changes_requested'
      }
    },
    usaceActions: {
      title: 'USACE Actions',
      inputOptions: {
        'System Type Change': yesNoNAOption,
        'Updated System Type': systemTypeOption,
        'DBA Alerted': yesNoNAOption,
        'Geometry Updated': yesNoNAOption,
        'Geometry Submitted': yesNoNAOption,
        'NLD Field Updated': yesNoNAOption,
        'FOUO Field Populated': yesNoNAOption,
        Notes: textOption,
        'Last Saved': dateOption,
        Email: emailOption
      },
      canUpdate: ['admin', 'usace'],
      statusOptions: {
        'In Progress': 'complete_usace_actions_incomplete',
        Complete: 'complete_usace_complete'
      }
    },
    //----------------------START streamline table options-----------------------
    initialQC: {
      title: 'Initial QC',
      hoverText: initialQCHoverText,
      inputOptions: {
        'Type of System': systemTypeOption,
        'Alignment Adjustments': alignmentAdjustmentOption,
        Notes: textOption,
        'Last Saved': dateOption,
        Email: emailOption
      },
      canUpdate: ['admin', 'usace', 'pts_admin'],
      statusOptions: {
        'In Progress': 'in_progress_initial_qc',
        Complete: 'complete_initial_qc'
      }
    },
    initialAnalyst: {
      title: 'Initial Analyst',
      hoverText: initialAnalystHoverText,
      inputOptions: {
        'FIRM/NFHL Symbol': yesNoOption,
        'Alignment Elevation Units': passFailOption,
        'Alignment has Closure': yesNoOption,
        'Alignment has Floodwall': yesNoOption,
        'Alignment has Road': yesNoOption,
        'Alignment has Railroad': yesNoOption,
        'Alignment has High Ground': yesNoOption,
        'Alignment has Bridge (CA style)': yesNoOption,
        'Best Leveed Area Method': leveedAreaOption,
        'Elevation Date': {
          rowType: 'dropdown',
          rowOptions: demDates
        },
        Notes: textOption,
        'Elevation Source': {
          rowType: 'dropdown',
          rowOptions: ['1-meter or better', '3-meter', 'Other']
        },
        'Last Saved': dateOption,
        Email: emailOption
      },
      canUpdate: ['admin', 'usace', 'pts_admin', 'pts_reviewer', 'pts_analyst'],
      statusOptions: {
        'In Progress': 'in_process',
        Complete: 'ready_for_review_detailed'
      }
    },
    finalQC: {
      title: 'Final QC',
      hoverText: finalQCHoverText,
      inputOptions: {
        'Type of System': systemTypeOption,
        'Alignment Acceptable': passFailOption,
        'Leveed Area Acceptable': passFailOption,
        'USACE Recommendation': {
          rowType: 'dropdown',
          rowOptions: ['Update', 'Remove', 'Recategorize']
        },
        'Final Notes': textOption,
        'Last Saved': dateOption,
        Email: emailOption
      },
      canUpdate: ['admin', 'usace', 'pts_admin', 'pts_reviewer'],
      statusOptions: {
        'Changes Requested': 'changes_requested',
        'In Progress': 'in_review_detailed',
        Complete: 'complete_usace_ready_for_review'
      }
    },

    //----------------------END streamline table options-----------------------
    parkingLot: {
      title: 'Parking Lot',
      inputOptions: {
        Reason: {
          rowType: 'dropdown',
          rowOptions: [
            'No DEM',
            'Partial DEM',
            'Flood Runout',
            'Long Floodwall',
            'Evaluated by Others',
            'Coastal Analysis',
            'Other'
          ]
        },
        Notes: textOption,
        'Last Saved': dateOption,
        Email: emailOption
      },
      canUpdate: [],
      statusOptions: {}
    },
    uneditable: {
      inputOptions: {
        'Last Saved': dateOption,
        Email: emailOption
      },
      canUpdate: [],
      statusOptions: {}
    }
  },
  statusByKey: {
    in_process: { Status: 'In Process', 'Detailed Status': '' },

    ready_for_review_detailed: {
      Status: 'Ready for Review',
      'Detailed Status': 'Detailed'
    },
    in_review_detailed: { Status: 'In Review', 'Detailed Status': 'Detailed' },
    ready_for_review_geospatial: {
      Status: 'Ready for Review',
      'Detailed Status': 'Geospatial'
    },
    in_review_geospatial: {
      Status: 'In Review',
      'Detailed Status': 'Geospatial'
    },
    ready_for_review_reasonableness: {
      Status: 'Ready for Review',
      'Detailed Status': 'Reasonableness'
    },
    in_review_reasonableness: {
      Status: 'In Review',
      'Detailed Status': 'Reasonableness'
    },

    //----------START streamline statuses----------
    in_progress_initial_qc: {
      Status: 'Pre-processed',
      'Detailed Status': 'Initial QC In Progress'
    },
    complete_initial_qc: {
      Status: 'Pre-processed',
      'Detailed Status': 'Ready for Processing'
    },
    //----------END streamline statuses----------

    changes_requested: { Status: 'Changes Requested', 'Detailed Status': '' },
    complete_usace_ready_for_review: {
      Status: 'Complete',
      'Detailed Status': 'USACE Ready for Review'
    },
    complete_usace_in_review: {
      Status: 'Complete',
      'Detailed Status': 'USACE In Review'
    },
    complete_usace_not_selected_for_review: {
      Status: 'Complete',
      'Detailed Status': 'USACE Not Selected for Review'
    },
    complete_usace_approved: {
      Status: 'Complete',
      'Detailed Status': 'USACE Approved'
    },
    complete_usace_changes_requested: {
      Status: 'Complete',
      'Detailed Status': 'USACE Changes Requested'
    },
    complete_usace_actions_incomplete: {
      Status: 'Complete',
      'Detailed Status': 'USACE Actions Incomplete'
    },
    complete_usace_complete: {
      Status: 'Complete',
      'Detailed Status': 'USACE Complete'
    }
  },

  tabByStatus: {
    original: {
      'Pre-processed': {
        Incomplete: 'Pre-Processing Details',
        'Ready for Initial QC': 'Processing Details',
        'Initial QC In Progress': 'Processing Details',
        'Ready for Processing': 'Processing Details'
      },
      Complete: {
        'USACE Ready for Review': 'USACE QA',
        'USACE In Review': 'USACE QA',
        'USACE Not Selected for Review': 'USACE Actions',
        'USACE Approved': 'USACE Actions',
        'USACE Changes Requested': 'USACE QA',
        'USACE Actions Incomplete': 'USACE Actions',
        'USACE Complete': 'USACE Actions'
      },
      'Changes Requested': 'Processing Details',
      'In Process': 'Processing Details',
      'Parking Lot': 'Processing Details',
      'Ready for Review': {
        Detailed: 'Detailed QC',
        Geospatial: 'Geospatial QC',
        Reasonableness: 'Reasonableness QC'
      },
      'In Review': {
        Detailed: 'Detailed QC',
        Geospatial: 'Geospatial QC',
        Reasonableness: 'Reasonableness QC'
      }
    },
    streamline: {
      'Pre-processed': {
        Incomplete: 'Pre-Processing Details',
        'Ready for Initial QC': 'Initial QC',
        'Initial QC In Progress': 'Initial QC',
        'Ready for Processing': 'Initial Analyst'
      },
      Complete: {
        'USACE Ready for Review': 'USACE QA',
        'USACE In Review': 'USACE QA',
        'USACE Not Selected for Review': 'USACE Actions',
        'USACE Approved': 'USACE Actions',
        'USACE Changes Requested': 'USACE QA',
        'USACE Actions Incomplete': 'USACE Actions',
        'USACE Complete': 'USACE Actions'
      },
      'Changes Requested': 'Initial Analyst',
      'In Process': 'Initial Analyst',
      'Parking Lot': 'Initial Analyst',
      'Ready for Review': {
        Detailed: 'Final QC',
        Geospatial: 'Initial QC',
        Reasonableness: 'Initial QC'
      },
      'In Review': {
        Detailed: 'Final QC',
        Geospatial: 'Initial QC',
        Reasonableness: 'Initial QC'
      }
    }
  },
  defaultValueByStatus: {
    'Changes Requested': 'changes_requested',
    Complete: {
      'USACE Ready for Review': 'complete_usace_ready_for_review',
      'USACE In Review': 'complete_usace_in_review',
      'USACE Not Selected for Review': 'complete_usace_not_selected_for_review',
      'USACE Approved': 'complete_usace_approved',
      'USACE Changes Requested': 'complete_usace_changes_requested',
      'USACE Actions Incomplete': 'complete_usace_actions_incomplete',
      'USACE Complete': 'complete_usace_complete'
    },
    'Pre-processed': {
      'Initial QC In Progress': 'in_progress_initial_qc',
      'Ready for Processing': 'complete_initial_qc'
    },
    'In Process': 'in_process',
    'In Review': {
      Detailed: 'in_review_detailed',
      Geospatial: 'in_review_geospatial',
      Reasonableness: 'in_review_reasonableness'
    },
    'Parking Lot': '',
    'Ready for Review': {
      Detailed: 'ready_for_review_detailed',
      Geospatial: 'ready_for_review_geospatial',
      Reasonableness: 'ready_for_review_reasonableness'
    }
  },
  statusProgressAmount: {
    // maps status string(s) to a numeric progress 1-14, or 0 if outside the normal flow
    'Pre-processed|Incomplete': 1,
    'Pre-processed|Ready for Initial QC': 1.5,
    'Pre-processed|Initial QC In Progress': 2,
    'Pre-processed|Ready for Processing': 2.5,
    'In Process|': 3,
    'Changes Requested|': 0,
    'Ready for Review|Detailed': 4,
    'In Review|Detailed': 5,
    'Ready for Review|Geospatial': 6,
    'In Review|Geospatial': 7,
    'Ready for Review|Reasonableness': 8,
    'In Review|Reasonableness': 9,
    'Complete|USACE Ready for Review': 10,
    'Complete|USACE In Review': 11,
    'Complete|USACE Changes Requested': 0,
    'Complete|USACE Not Selected for Review': 12,
    'Complete|USACE Approved': 12,
    'Complete|USACE Actions Incomplete': 13,
    'Complete|USACE Complete': 14,
    'Parking Lot|Evaluated by Others': 0,
    'Parking Lot|Flood Runout': 0,
    'Parking Lot|Coastal Analysis': 0,
    'Parking Lot|Long Floodwall': 0,
    'Parking Lot|No DEM': 0,
    'Parking Lot|Other': 0,
    'Parking Lot|Partial DEM': 0
  }
};

export default config;
